const columns = {
  name: "columns",
  path: "/columns",
  title: "columns",
  description: "Utilities for controlling the number of columns within an element.",
  value: {
    "columns":{
        "columns-<number>": "<number>",
    "columns-auto": "auto",
    "columns-none": "none",
    }
    // ...more values...
  },
  exampleData: [
                    {
                        "title": "columns-<number>",
                        "description": "utilities like columns-3 to set the number of columns that should be created for the content within an element:",
                        "moreDescription": "",
                        "parentClass": "columns-2 md:columns-3 gap-6 *:mb-6",
                        "example": {
                            "element": "img",
                            "src": [
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-3/2 object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-3/2 object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-3/2 object-cover w-full"
                                },
                            ],
                            "className": "rounded-lg overflow-hidden",
                            "code": `<div class="columns-2 md:columns-3 gap-6 *:mb-6 ...">
  <img class="aspect-3/2 ..." src="/img/image.jpg" />
  <img class="aspect-square ..." src="/img/image.jpg" />
  <img class="aspect-square ..." src="/img/image.jpg" />
  <!-- ... -->
</div>`
                        }
                    },
                    {
                        "title": "columns-xs",
                        "description": "utilities like to set the ideal column width for the content within an element:",
                        "moreDescription": "",
                        "parentClass": "columns-xs gap-6 *:mb-6",
                        "example": {
                            "element": "img",
                            "src": [
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-3/2 object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-square object-cover w-full"
                                },
                                {
                                    "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                                    "className": "aspect-3/2 object-cover w-full"
                                },
                            ],
                            "className": "rounded-lg overflow-hidden",
                            "code": `<div class="columns-xs gap-6 *:mb-6 ...">
  <img class="aspect-3/2 ..." src="/img/image.jpg" />
  <img class="aspect-square ..." src="/img/image.jpg" />
  <img class="aspect-square ..." src="/img/image.jpg" />
  <!-- ... -->
</div>`
                        }
                    }
                ]
};

export default columns;